import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

const UserRankingBar = ({ selectedValue, userRankingGUID, mediaGUID, getArtists }) => {

  const handleClick = async (value) => {
    fetch(`/api/user-ranking/`, {
      method: 'PUT',
      body: JSON.stringify({
        userRankingUserGUID: process.env.REACT_APP_USER_GUID,
        userRankingRefGUID: mediaGUID,
        userRankingRank: value
      }),
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        if (response.ok) { // Checks if the status is in the range 200-299
          getArtists(); // Only set data if HTTP status is 200-299
        } else {
          return null;
        }
      })
      .catch((error) => {
      });
  };

  const deleteUserRanking = async (value) => {
    fetch(`/api/user-ranking/${userRankingGUID}`, {
      method: 'DELETE',
    })
      .then((response) => {
        if (response.ok) { // Checks if the status is in the range 200-299
          getArtists(); // Only set data if HTTP status is 200-299
        } else {
          return null;
        }
      })
      .catch((error) => {
      });
  };

  return (
    <>
      <ButtonGroup>
        {[1, 2, 3, 4, 5].map((value) => (
          <Button
            key={value}
            className='p-3 px-4'
            color={value === selectedValue ? 'primary' : 'dark'}
            onClick={() => handleClick(value)}
          >
            {value}
          </Button>
        ))}
      </ButtonGroup>
      <Button
        className='ms-2 p-3'
        disabled={selectedValue == null}
        color='dark'
        onClick={() => deleteUserRanking()}
      >
        <FontAwesomeIcon icon={faTimes} />
      </Button>
    </>
  );
};

export default UserRankingBar;